import { SxProps, Theme } from '@mui/material/styles'
import type { SystemStyleObject } from '@mui/system'

export const inputPaperVariant: SxProps<Theme> = {
    /* Standard MUI inputs */
    '& .MuiOutlinedInput-root, & .MuiInputBase-root': {
        backgroundColor: 'background.paper',
    },

    /* MUI X Pickers */
    '& .MuiPickersInputBase-root, & .MuiPickersOutlinedInput-root': {
        backgroundColor: 'background.paper',
    },

    /* Actual <input> element (important for autofill & inner transparency) */
    '& .MuiOutlinedInput-input, & .MuiInputBase-input, & .MuiPickersInputBase-input':
        {
            backgroundColor: 'transparent',
        },
}

/** Theme-aware paper surface for outlined / picker inputs. Use in `styled()` and `sx`. */
export const inputPaperSurface = (theme: Theme): SystemStyleObject<Theme> => ({
    '& .MuiOutlinedInput-root, & .MuiPickersOutlinedInput-root, & .MuiPickersInputBase-root':
        {
            backgroundColor: theme.palette.background.paper,
        },
    '& .MuiOutlinedInput-input, & .MuiPickersInputBase-input': {
        backgroundColor: 'transparent',
    },
})
